import axios from "axios";

const endpoint = process.env.VUE_APP_API_URL;

export default axios.create({
  baseURL: endpoint,
});
